import React, { useState } from "react";
import Article from "./article/articles";
import Layout from "../../components/layout";
import { graphql } from "gatsby";
import { BiSearchAlt } from "react-icons/bi";

const BlogPage = ({ data }) => {
  const [state, setState] = useState({
    filteredPosts: [],
    query: "",
  });

  const allPosts = data.allMdx.nodes;

  const handleInputChange = (event) => {
    const query = event.target.value;
    const filteredPosts = allPosts.filter((post) => {
      console.log(post.frontmatter.title);
      const { title, tags } = post.frontmatter;

      return (
        title.toLowerCase().includes(query.toLowerCase()) ||
        (tags && tags.join("").toLowerCase().includes(query.toLowerCase()))
      );
    });
    setState({
      query,
      filteredPosts,
    });
  };

  const posts = state.query ? state.filteredPosts : allPosts;

  return (
    <Layout pageTitle="Articles de blog">
      <p>
        Les articles que j'écris, sur la tech et sur d'autres choses
        éventuellement.
      </p>
      <div className="relative ...">
        <input
          className="bg-stone-100 static pl-10 py-2 flex my-10 w-full rounded search"
          type="text"
          aria-label="Search"
          placeholder="Recherche un artice par tag, titre ou description..."
          value={state.query}
          onChange={handleInputChange}
        />
        <div className="absolute bottom-2 left-2 ...">
          <BiSearchAlt size="23px" className="search-icon" />
        </div>
      </div>

      <div className="flex flex-col lg:flex-row lg:flex-wrap flex-nowrap justify-between">
        {posts.map((node) => (
          <Article
            key={node.id}
            id={node.id}
            title={node.frontmatter.title}
            date={node.frontmatter.date}
            slug={node.slug}
            tags={node.frontmatter.tags}
          ></Article>
        ))}
      </div>
    </Layout>
  );
};
export default BlogPage;

export const query = graphql`
  query {
    allMdx(sort: { fields: frontmatter___date, order: DESC }) {
      nodes {
        frontmatter {
          date(formatString: "D/M/YYYY")
          title
          tags
        }
        id
        slug
      }
    }
  }
`;
